import type { Component } from 'svelte';
import AdminUsers from '$lib/components/AdminUsers.svelte';
import ProjectDashboard from '$lib/components/ProjectDashboard.svelte';
import UnitDashboard from '$lib/components/UnitDashboard.svelte';
import UserGuide from '$lib/components/UserGuide.svelte';
import Workspace from '$lib/components/workspace/Workspace.svelte';
import { parseHash } from './hash';
import type { Route, RouteLayout } from './types';

export type ResolvedRoute = {
	route: Route;
	component: Component;
	layout: RouteLayout;
};

const entries: Array<{
	match: (hash: string) => boolean;
	component: Component;
	layout: RouteLayout;
}> = [
	{
		match: (h) => {
			const n = h.trim();
			return n === '#/' || n === '' || n === ' ' || n === '#';
		},
		component: ProjectDashboard,
		layout: 'main'
	},
	{
		match: (h) => /^#\/guide$/.test(h),
		component: UserGuide,
		layout: 'main'
	},
	{
		match: (h) => /^#\/admin\/users$/.test(h),
		component: AdminUsers,
		layout: 'main'
	},
	{
		match: (h) => /^#\/project\/\d+$/.test(h),
		component: UnitDashboard,
		layout: 'main'
	},
	{
		match: (h) => /^#\/unit\/\d+/.test(h),
		component: Workspace,
		layout: 'workspace'
	}
];

export function resolveRoute(hash: string): ResolvedRoute {
	const route = parseHash(hash);
	const normalized = hash.trim() || '#/';

	for (const entry of entries) {
		if (entry.match(normalized)) {
			return { route, component: entry.component, layout: entry.layout };
		}
	}

	return { route, component: ProjectDashboard, layout: 'main' };
}
